import styles from './style.module.css';
import Item from './item';
import Icon from '../../icon';

export default function FieldBase({
	err,
	content,
	type='layer0',
	label,
	placeholder='Введите значение',
	value='',
	onChange=(() => {}),
	children,
	icon,
	text,
	onClick,
	disabledInput,
	leftIcon,
	className,
	...props
}) {
	const cls = [styles.body, styles[type], err ? styles.errBox : null].filter(Boolean).join(' ');
	const inpCls = [styles.input, className].filter(Boolean).join(' ');
	return <div className={styles.container}>
		{label && <label className={styles.label}>{label}</label>}
		<div className={cls}>
			{leftIcon ? <Icon className={styles.left} {...leftIcon} /> : null}
			<input placeholder={placeholder} className={inpCls} value={value} onChange={onChange} type={content === 'password' ? content : 'text'} {...props} disabled={props.disabled || disabledInput} />
			<Item err={!!err} disabled={props.disabled} icon={icon} text={text} onClick={onClick} children={children} />
		</div>
		{(err && typeof err === 'string' ) ? <span className={styles.err}>{err.toString()}</span> : null}
	</div>
}

